module.exports = __webpack_public_path__ + "static/media/ic_删除1.3e48a539.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_删除1.svg
// module id = 346
// module chunks = 0